module.exports = __webpack_public_path__ + "static/p11_cencerro-8c49ac2efbbfdd2ab1ea7ab0446baeea.png";